import { useSyncExternalStore } from 'react'

import {
  getCartCount,
  getCartLines,
  subscribeCart,
  type CartLine,
} from '../cart/cartStore'

export const useCart = (): { lines: CartLine[]; count: number } => {
  const lines = useSyncExternalStore(subscribeCart, getCartLines, getCartLines)
  const count = useSyncExternalStore(subscribeCart, getCartCount, getCartCount)
  return { lines, count }
}
